export default "__VITE_ASSET__CTMZTgUY__"